import { render, staticRenderFns } from "./saveRecordNameDialog.vue?vue&type=template&id=9853b830&scoped=true"
import script from "./saveRecordNameDialog.vue?vue&type=script&lang=js"
export * from "./saveRecordNameDialog.vue?vue&type=script&lang=js"
import style0 from "./saveRecordNameDialog.vue?vue&type=style&index=0&id=9853b830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9853b830",
  null
  
)

export default component.exports